var debug = function(v) {
	$(arguments).each(function(i, item) {
		console.log(item)
	})
}
var cityChange;
var calculate;
var calculatorLoading = false;


var CITY_CODES_MAP = {
    CA: {
        'SAN FRANCISCO': 'SF',
        'SAN DIEGO': 'SD',
        'LOS ANGELES': 'LA',
        'ORANGE': 'OC',
        'ALAMEDA': 'AL',
        'CONTRA COSTA': 'CC',
        'SANTA CLARA': 'CC',
        'SAN MATEO': 'SM',
    },
    WA: 'KI',
    NH: 'BM',
    NH: 'MA',
    MD: 'DC',
    'DISTRICT OF COLUMBIA': 'DC',
    IN: 'CH',
    IL: 'CH',
    WV: 'VA',
    NJ: 'NY',
};


function initRoiCalc() {

	var getCityData = function(cityCode, sellPrice) {
		if (typeof cityCode == "undefined")
		{
			cityCode = $("#cityList").val();
		}
		var cities =
		{
			LA:
			{ //Los angeles
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.0056,
				exciseTitle: 'County Transfer Tax',
				etax: 0.56,
				escrow: (0.00175 * sellPrice) + 200,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 500,
				title: sellPrice * (0.0018) + 411.48
			},
			OC:
			{ //Orange county
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.0011,
				exciseTitle: 'County Transfer Tax',
				etax: 0.11,
				escrow: 0.0025 * sellPrice,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 1500,
				title: (0.0019 * sellPrice) + 469.28

			},
			SD:
			{ // San Diego
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.0011,
				exciseTitle: 'County Transfer Tax',
				etax: 0.11,
				escrow: (sellPrice * (0.0015)) + 300,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 1500,
				title: (sellPrice * (0.002)) + 519.75
			},
			SF:
			{ // San Francisco
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: undefined, //will be calculated
				exciseTitle: "County Transfer Tax",
				//etax: 0.11,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				sellerAgentComissionTax: 'between .68% and .75%',
				miscFee: 1000,
				title: 0
			},
			AL:
			{ // Alameda
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.0011,
				exciseTitle: "County Transfer Tax",
				etax: 0.11,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 1000,
				title: 0
			},
			CC:
			{ // Contra Costa
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.0011,
				exciseTitle: "County Transfer Tax",
				etax: 0.11,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 1000,
				title: 0
			},
			SC:
			{ // Santa Clara
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.0011,
				exciseTitle: "County Transfer Tax",
				etax: 0.11,
				escrow: (0.00175 * sellPrice) + 200,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 1000,
				title: 0
			},
			SM:
			{ // San Mateo
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.0011,
				exciseTitle: "County Transfer Tax",
				etax: 0.11,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 1000,
				title: 0
			},
			KI:
			{ // King CO Seattle
				buyCommission: 0.030,
				sellComission: 0.030,
				exciseTax: 0.0178,
				exciseTitle: "Excise Tax",
				etax: 1.78,
				escrow: (sellPrice / 2000) + 375,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 200,
				title: (sellPrice * 0.0016) + 419
			},
			BM:
			{ // Boston Massachusets / Suffolk County
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.00456,
				exciseTitle: "County Transfer Tax",
				etax: 0.456,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 1000,
				title: 0
			},
			DC:
			{ // District of Columbia
				buyCommission: 0.025,
				sellComission: 0.030,
				exciseTax: undefined, //will be calculated
				exciseTitle: "County Transfer Tax",
				//etax: 0.11,
				escrow: 550,
				escrowFeeTitle: 'Escrow Fee',
				sellerAgentComissionTax: 'between 1.1% and 1.45%',
				miscFee: 500,
				title: 0
			},
			CH:
			{ // Chicago
				buyCommission: 0.025,
				sellComission: 0.025,
				exciseTax: 0.0015,
				exciseTitle: "County Transfer Tax",
				etax: 0.15,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 1500,
				title: 0
			},
			VA:
			{ // Virginia
				buyCommission: 0.030,
				sellComission: 0.030,
				exciseTax: 0.001,
				exciseTitle: "Grantor's Tax",
				etax: 0.10,
				escrow: 600,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 650,
				title: 0
			},
			NY:
			{ // New York City
				buyCommission: 0.030,
				sellComission: 0.030,
				exciseTax: undefined, //will be calculated
				exciseTitle: "Realty Transfer and Mortgage",
				//etax: 0.4,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 0,
				title: 0
			},
			FL:
			{ // Miami
				buyCommission: 0.030,
				sellComission: 0.030,
				exciseTax: 0.007,
				exciseTitle: "Conveyance Tax",
				etax: 0.70,
				escrow: 600,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 0,
				title: 0
			},
			CO:
			{ // Denver
				buyCommission: 0.028,
				sellComission: 0.028,
				exciseTax: 0.001,
				exciseTitle: "County Transfer Tax",
				etax: 0.11,
				escrow: 800,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 120,
				title: 100
			},
			OR:
			{ // Portland
				buyCommission: 0.030,
				sellComission: 0.030,
				exciseTax: 0.00,
				exciseTitle: "County Transfer Tax",
				etax: 0.00,
				escrow: 400,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 170,
				title: 0
			},
			TX:
			{ // Austin
				buyCommission: 0.030,
				sellComission: 0.030,
				exciseTax: 0.00,
				exciseTitle: "County Transfer Tax",
				etax: 0.00,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 700,
				title: 200
			},
			HI:
			{ // Honolulu
				buyCommission: 0.030,
				sellComission: 0.030,
				//exciseTax: 0.001,
				exciseTitle: "Conveyance Tax",
				//etax: 0.11,
				escrow: (0.002 * sellPrice) + 500,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 350,
				title: 0
			},
			AZ:
			{ // Phoenix
				buyCommission: 0.030,
				sellComission: 0.030,
				exciseTax: 0.00,
				exciseTitle: "County Transfer Tax",
				etax: 0.00,
				escrow: 0,
				escrowFeeTitle: 'Escrow Fee',
				miscFee: 0,
				title: 800
			}

		}

		var city = cities[cityCode] || cities[cityCode = 'SF'];
		if (!city.sellerAgentComissionTax)
		{
			city.sellerAgentComissionTax = city.etax + "%";
		}
		if (cityCode == "SF")
		{
			if (sellPrice < 1000000)
			{
				city.exciseTax = 0.0068;
			}
			if (sellPrice >= 1000000)
			{
				city.exciseTax = 0.0075;
			}
		}
		if (cityCode == "DC")
		{
			if (sellPrice <= 400000)
			{
				city.exciseTax = 0.011;
			}
			if (sellPrice > 400000)
			{
				city.exciseTax = 0.0145;
			}
		}
		if (cityCode == "NY")
		{
			if (sellPrice <= 550000)
			{
				city.exciseTax = 0.01;
			}
			if (sellPrice > 550000)
			{
				city.exciseTax = 0.02625;
			}
		}
		if (cityCode == "HI")
		{
			if (sellPrice < 600000)
			{
				city.exciseTax = 0.001;
			}
			if (sellPrice >= 600000 && sellPrice < 1000000)
			{
				city.exciseTax = 0.002;
			} else if (sellPrice >= 1000000 && sellPrice < 2000000) {
				city.exciseTax = 0.003;
			} else if (sellPrice >= 2000000 && sellPrice < 4000000) {
				city.exciseTax = 0.005;
			} else if (sellPrice >= 4000000 && sellPrice < 6000000) {
				city.exciseTax = 0.007;
			} else if (sellPrice >= 6000000 && sellPrice < 10000000) {
				city.exciseTax = 0.009;
			} else if (sellPrice >= 10000000) {
				city.exciseTax = 0.01;
			}
		}
		return city;
	}

	//Functions
	cityChange = function() {
		var cityData = getCityData($("#cityList").val());
		$(".ex_tax_label").html(cityData.exciseTitle + ' ')
		$(".escrow_fee_label").html(cityData.escrowFeeTitle + ' ')
		$("#ex_tax_perc").html(cityData.sellerAgentComissionTax)
		
		$("#tt_bcom_amount").html((cityData.buyCommission * 100) + '%')
		
		//$("#tt_scom_amount").html((cityData.sellComission * 100) + '%');
		//$("#sellComissionPercent").val((cityData.sellComission * 100) + '%');
		
		//$("#buyCommissionPercent").html((cityData.buyCommission * 100).toFixed(2) + '%');
		$("#buyCommissionPercent").val(Math.round(cityData.buyCommission * 10000) / 100);

		$(".location").text($("#cityList option:selected").text());

		cityCode = $("#cityList").val();
		newState = "ca";
		switch(cityCode) {
			case 'SF':
				newCity = "san+francisco";
				break;
			case 'SD':
				newCity = "san+diego";
				break;
			case 'LA':
				newCity = "los+angeles";
				break;
			case 'OC':
				newCity = "irvine";
				break;
			case 'AL':
				newCity = "oakland";
				break;
			case 'CC':
				newCity = "concord";
				break;
			case 'SC':
				newCity = "san+jose";
				break;
			case 'SM':
				newCity = "san+mateo";
				break;
			case 'KI':
				newCity = "seattle";
				newState = "wa";
				break;
			case 'BM':
				newCity = "boston";
				newState = "ma";
				break;
			case 'DC':
				newCity = "washington";
				newState = "dc";
				break;
			case 'CH':
				newCity = "chicago";
				newState = "il";
				break;
			case 'VA':
				newCity = "richmond";
				newState = "va";
				break;
			case 'NY':
				newCity = "new+york";
				newState = "ny";
				break;
			case 'FL':
				newCity = "miami";
				newState = "fl";
				break;
			case 'CO':
				newCity = "denver";
				newState = "co";
				break;
			case 'OR':
				newCity = "portland";
				newState = "or";
				break;
			case 'TX':
				newCity = "austin";
				newState = "tx";
				break;
			case 'HI':
				newCity = "honolulu";
				newState = "hi";
				break;
			case 'AZ':
				newCity = "phoenix";
				newState = "az";
				break;
		}
		$('#chartLoading').show();
		$('#roiChart').attr('src','https://charts.altosresearch.com/altos/app?pai=55850392&s=median&ra=a,c&q=a&st='+newState+'&c='+newCity+'&z=a&sz=l&ts=e&service=chart&theme=newChart');
		setTimeout(function(){$('#chartLoading').hide()},2000);
	};


	calculate = function(cityCode, silent, sellingPrice, log) {
		if (log == undefined) {
			log = true;
		}
		//defining local variables
		if (typeof cityCode == "undefined")
		{
			cityCode = $("#cityList").val();
		}
		if (typeof sellingPrice == "undefined")
		{
			sellPrice = $("#selling_price").val();
		}

		var mortgage = $("#out_mortgage").val();
		if (sellPrice == "$" || mortgage == "$")
		{
			return false;
		}

		sellPrice = toNumber(sellPrice);
		mortgage = toNumber(mortgage);
		if (sellPrice == "")
		{
			sellPrice = 0;
		}
		if (mortgage == "")
		{
			mortgage = 0;
		}

		if ($("#sellComissionPercent").val() == "" || sellPrice < 100000)
		{
			if (silent == undefined) {
				popupText('Please make sure you select a Seller Agent Commission and enter a valid Home Price.', 250, 'auto');
			}
			return false;
		}

		var net1 = sellPrice - mortgage;
		var cityData = getCityData(cityCode, sellPrice);
		var buyCommission = cityData.buyCommission;
		var sellComission = cityData.sellComission;
		var title = cityData.title;
		var escrow = cityData.escrow;
		var miscFee = cityData.miscFee;
		var exciseTax = cityData.exciseTax;
		console.log(cityData);

		var sellComissionPercentInputValue = toNumber($("#sellComissionPercent").val(), true);
		if (sellComissionPercentInputValue != "")
		{
			sellComission = sellComissionPercentInputValue / 100;
		}
		var buyComissionPercentInputValue = toNumber($("#buyCommissionPercent").val(), true);
		if (buyComissionPercentInputValue != "")
		{
			buyCommission = buyComissionPercentInputValue / 100;
		}

		var net = sellPrice - mortgage - (truncateNumber(buyCommission * sellPrice)) - truncateNumber((sellComission * sellPrice)) - truncateNumber((exciseTax * sellPrice)) - truncateNumber(title) - truncateNumber(escrow) - truncateNumber(miscFee);

		$('#selling_price').val(formatPrice(sellPrice));
		$('#out_mortgage').val(formatPrice(mortgage));
		$('#buy_commission_number').html(formatPrice(Math.round(buyCommission * sellPrice), true));
		$('#listing_commission_number').html(formatPrice(Math.round(sellComission * sellPrice), true));
		$('#excise_tax_number').html(formatPrice(Math.round(exciseTax * sellPrice), true));
		$('.exciseTaxNumberForSellers').html('$' + formatRebateAmts(Math.round(exciseTax * sellPrice)));

		if (cityCode == "SF") {
			$('#title_tax_number').html('Paid by Buyer');
			$('#escrow_fee_number').html('Paid by Buyer');
		} else {
			$('#title_tax_number').html(formatPrice(Math.round(title), true));
			$('#escrow_fee_number').html(formatPrice(Math.round(escrow), true));
		}
		$('#misc_fee_number').html(formatPrice(Math.round(miscFee), true));
		$('.miscFeeNumberForSellers').html('$' + formatRebateAmts(Math.round(miscFee)));

		var savingsFormula = (6 - (sellComission*100) - (buyCommission*100)) * sellPrice / 100;
		$('#savingsNumber').html(formatPrice(Math.round(savingsFormula), true));
		$('.savingsNumber').html(Math.round(savingsFormula), true);
		$('.savingsNumberForSellers').html('$' + formatRebateAmts(Math.round(savingsFormula)));

		$('#net_result').html(formatPrice(Math.round(net), true));
		$('.net_result').html(formatPrice(Math.round(net), true));
		$('.netResultForSellers').html('$' + formatRebateAmts(net));


		$('#tt_sell_price').text(formatPrice(sellPrice));

		$('#buy_commission_number').addClass('pulse');
		$('#listing_commission_number').addClass('pulse');
		$('#excise_tax_number').addClass('pulse');
		$('#title_tax_number').addClass('pulse');
		$('#escrow_fee_number').addClass('pulse');
		$('#misc_fee_number').addClass('pulse');
		$('#savingsNumber').addClass('pulse');
		$('.savingsNumber').addClass('pulse');
		$('.net_result').addClass('pulse');

		setTimeout(function(){
			$('#buy_commission_number').removeClass('pulse');
			$('#listing_commission_number').removeClass('pulse');
			$('#excise_tax_number').removeClass('pulse');
			$('#title_tax_number').removeClass('pulse');
			$('#escrow_fee_number').removeClass('pulse');
			$('#misc_fee_number').removeClass('pulse');
			$('#savingsNumber').removeClass('pulse');
			$('.savingsNumber').removeClass('pulse');
			$('.net_result').removeClass('pulse');
		},1000);
		
		if (sellPrice > 0 && log) {
			requestId = $('#calcRequestId').val() ? $('#calcRequestId').val() : 0;
			if (calculatorLoading) {
				//do nothing
			} else {
				calculatorLoading = true;
				$.get('trackCalc?mortgage='+encodeURIComponent(mortgage)+'&comm='+encodeURIComponent(sellComission * 100)+'&saleprice='+encodeURIComponent(sellPrice)+'&county='+encodeURIComponent($("#cityList option[value='"+$("#cityList").val()+"']").text())+'&reqId='+encodeURIComponent(requestId), function(){
					calculatorLoading = false;
				});
			}
		}

	};
	/**
	 * Formatize price
	 * @param {Numeric} price
	 * @param {Bool} truncate - truncate number
	 */
	var formatPrice = function(price, truncate) {
		var priceNum = price;
		if (truncate == true)
		{
			if (priceNum >= 1000000000 || priceNum <= -1000000000)
			{
				priceNum = Math.round(priceNum / 1000000000) + "B"
			}
			else
			{
				if (priceNum >= 1000000 || priceNum <= -1000000)
				{
					//priceNum = Math.round(priceNum / 1000000) + "M"
					priceNum = (Math.round(priceNum / 1000)/1000) + "M"
				}
				else
				{
					if (priceNum >= 1000 || priceNum <= -1000)
					{
						priceNum = Math.round(priceNum / 100) / 10 + "K"
					}
					else
					{
						priceNum = Math.round(priceNum)
					}
				}
			}
		}
		return '$' + priceNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	/**
	 * Converts variable to numeric
	 * @param {Mixed} v
	 */
	function toNumber(v) {
		if (v == undefined)
		{
			return false;
		}
		v = v.toString().replace(/[^0-9.]/g, "");
		if (isNumeric(v))
		{
			if (v.match(/\./))
			{
				return parseFloat(v);
			}
			else
			{
				return parseInt(v);
			}
		}
		return 0;
	}


    function formatRebateAmts(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }



	/**
	 * Finds whether a variable is a number or a numeric string
	 *
	 * @param {Mixed} value
	 * @return {Boolean}
	 */
	function isNumeric(value) {
		if (value === null)
		{
			return false;
		}
		if (value === undefined)
		{
			return false;
		}
		if (value == "")
		{
			return false;
		}
		value = value.toString().replace(/[^0-9.]/g, "");
		if (isNaN(value) == true)
		{
			return false;
		}
		else
		{
			return true;
		}
	}

	/**
	 * Truncate round number price
	 * @param {Numeric} price
	 */
	var truncateNumber = function(number) {
		if (number >= 1000000000 || number <= -1000000000)
		{
			return Math.round(number / 1000000000) * 1000000000
		}
		else
		{
			if (number >= 1000000 || number <= -1000000)
			{
				return Math.round(number / 1000000) * 1000000
			}
			else
			{
				if (number >= 1000 || number <= -1000)
				{
					return (Math.round(number / 100)) * 100
				}
				else
				{
					return Math.round(number)
				}
			}
		}
	}

	cityChange();
	$("#cityList").change(function() {
		cityChange();
		calculate($("#cityList").val(),true);
	});

	var commisionSelect = $('#sellComissionPercent');
	var outMortage = $("#out_mortgage");
	var sellingPrice = $("#selling_price");

	var checkAndCalculate = function() {
		var commisionVal = parseFloat(commisionSelect.val());
		var outMortageVal = toNumber(outMortage.val());
		var sellingPriceVal = toNumber(sellingPrice.val());
		if (sellingPriceVal>100000 && commisionVal) {
			 calculate($("#cityList").val());
		}
	}

	/*
	commisionSelect.bind("change",function(e){
		checkAndCalculate();
	});
	outMortage.bind("change keyup", function(e){
		checkAndCalculate();
	});
	sellingPrice.bind("change keyup", function(e){
		checkAndCalculate();
	});

	cityChange();
	$("#cityList").on("change",function() {
		cityChange();
		//calculate($("#cityList").val(),true);
	});
	*/

	/*
	$("#commissionCalc .forminput").bind("keyup blur", function() {
		calculate($("#cityList").val());
	});
	*/
	$("#calculateButton, .calculateButton").bind("click", function() {
		calculate($("#cityList").val());
	});
	calculate($("#cityList").val(),true);
	
}

$(document).ready(function() {
	initRoiCalc();
})
